import * as DOMPurify from "dompurify";
import {NotificationType} from "./Enums/NotificationType";
import type INotificationConfiguration from "./Interfaces/INotificationConfiguration";

export default class NotificationConfiguration implements INotificationConfiguration {
    public body?: string;
    private mSanitizedHtml?: HTMLElement | string;
    public container?: JQuery;
    public customHeading?: string;
    public hasSpinner?: boolean;
    public isDismissible?: boolean;
    public messages?: string[];
    public detailMessages?: string[] | null;
    public notificationType: NotificationType = NotificationType.Info;
    public retryCallback?: (event?: JQuery.ClickEvent) => void;
    public retryText?: string;
    public drawDelay?: number;
    public autoDismissOnSuccess?: boolean;
    public minorText?: string;

    public constructor(init?: Partial<NotificationConfiguration>) {
        Object.assign(this, init);
    }

    public get sanitizedBody(): HTMLElement | string | null {
        if (this.mSanitizedHtml === undefined) {
            if (this.body === undefined) {
                return null;
            }

            const htmlWrapper = document.createElement("template");
            htmlWrapper.innerHTML = DOMPurify.sanitize(this.body);

            if (htmlWrapper.childElementCount > 0) {
                this.mSanitizedHtml = htmlWrapper.firstElementChild as HTMLElement;
            } else {
                this.mSanitizedHtml = htmlWrapper.innerHTML;
            }
        }

        return this.mSanitizedHtml;
    }

    public buildBodyAsHtmlList(): void {
        if (this.messages === undefined) {
            return;
        }

        const listContainerEl = document.createElement("ul");

        for (const message of this.messages) {
            const sanitizedMessage = DOMPurify.sanitize(message);

            const listContainerItemEl = document.createElement("li");
            listContainerItemEl.innerHTML = sanitizedMessage;
            listContainerEl.appendChild(listContainerItemEl);
        }

        this.mSanitizedHtml = listContainerEl;
    }
}
